const ACTION_TYPES = {
  OPEN_NEW_BULK_DOWNLOAD: 'OPEN_NEW_BULK_DOWNLOAD',
  CLOSE_BULK_DOWNLOAD: 'CLOSE_BULK_DOWNLOAD'
}

export default ACTION_TYPES
